import { YouTube } from "$components";
import MobxImage from "../../../../content/articles/2018-03-13-easy-mobx-redux-comparison/mobx-diagram.jpg";
import ReduxImage from "../../../../content/articles/2018-03-13-easy-mobx-redux-comparison/redux-diagram.jpg";
import React from 'react';
export default {
  YouTube,
  MobxImage,
  ReduxImage,
  React
};